import CollectionCard from './CollectionCard.js';

class CollectionCardList extends CollectionCard { 
  constructor() {
    super();
    this.trackList = this.querySelector('.card-information__tracklist ol');
    this.trackListButton = this.querySelector('.card-information__tracklist button[data-expand-tracklist]');
    
    if (this.trackListButton) {
      this.trackListButton.addEventListener('click', this.expandTracklist.bind(this));
    }
  
    this.lazyloadHoverSection();
  }

  getTracklist() {
    return JSON.parse(this.querySelector('.metafield-json').textContent);
  }

  expandTracklist(event) {
    if (event.target.hasAttribute("data-expand-tracklist")) {
      this.trackList.classList.add('expanded');
      this.trackListButton.remove();
    }
  }

  // Method to setup IntersectionObserver
  lazyloadHoverSection() {
    const observerOptions = {
      rootMargin: '0px 0px 200px 0px', // Trigger when 200px from bottom of viewport
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Call the inherited renderHoverSection method
          this.renderHoverSection();
          observer.unobserve(entry.target); // Stop observing after triggering
        }
      });
    }, observerOptions);

    observer.observe(this);
  }
}

export default CollectionCardList; 